module.exports = __webpack_public_path__ + "media/Loops Keys.e276df18.wav";